var _circle, _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 14.5,
    fill: "#37715B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.935 15.7959C13.6952 15.9561 13.4133 16.0417 13.1248 16.0417C12.7381 16.0417 12.3671 15.888 12.0936 15.6145C11.8201 15.341 11.6665 14.9701 11.6665 14.5833C11.6665 14.2949 11.752 14.0129 11.9123 13.7731C12.0725 13.5333 12.3003 13.3464 12.5668 13.236C12.8332 13.1256 13.1265 13.0968 13.4093 13.153C13.6922 13.2093 13.9521 13.3482 14.156 13.5521C14.36 13.7561 14.4989 14.0159 14.5551 14.2988C14.6114 14.5817 14.5825 14.8749 14.4722 15.1414C14.3618 15.4079 14.1749 15.6357 13.935 15.7959Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0646 13.3708C21.3045 13.2105 21.5864 13.125 21.8748 13.125C22.2616 13.125 22.6325 13.2786 22.906 13.5521C23.1795 13.8256 23.3332 14.1966 23.3332 14.5833C23.3332 14.8718 23.2476 15.1537 23.0874 15.3935C22.9272 15.6334 22.6994 15.8203 22.4329 15.9307C22.1664 16.041 21.8732 16.0699 21.5903 16.0136C21.3074 15.9574 21.0476 15.8185 20.8436 15.6145C20.6397 15.4106 20.5008 15.1507 20.4445 14.8678C20.3883 14.585 20.4171 14.2917 20.5275 14.0253C20.6379 13.7588 20.8248 13.531 21.0646 13.3708Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 20,
    width: 13,
    height: 3,
    rx: 1.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkSelected);
export default __webpack_public_path__ + "static/media/ok-selected.4aec54ba11397acd9da4e060a0c276a0.svg";
export { ForwardRef as ReactComponent };